import Calendar from "@/utils/calendar";
import moment from "moment";

const singleProductTypes = ["多品", "单品"];
const deliveryStatusList = {
  '-1':'待上架',
  0: "待处理",
  1: "拣货中",
  2: "打标中",
  3: "打包中",
  4: "打包完成",
  5: "已发货",
  10: "已取消",
};
export const columns = [
  {
    title: "发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
    rowKey: "key",
    fixed: "left",
    width: 290,
    scopedSlots: {
      customRender: "shipmentCodeAction",
    },
  },
  {
    title: "订单编号",
    dataIndex: "platformOrderNo",
    key: "platformOrderNo",
    width: 220,
    scopedSlots: {
      customRender: "platformOrderNo",
    },
  },
  {
    title: "发货数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return text + "件";
    },
  },
  // {
  //     title: '是否可发',
  //     key: 'canDelivery',
  //     dataIndex: 'canDelivery',
  //     scopedSlots: {
  //         customRender: 'canDeliveryAction'
  //     }
  // },
  {
    title: "单/多品",
    key: "singleProduct",
    dataIndex: "singleProduct",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return singleProductTypes[text];
    },
  },
  {
    title: "发货状态",
    dataIndex: "deliveryStatus",
    key: "deliveryStatus",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return deliveryStatusList[text];
    },
  },
  {
    title: "店铺名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
    rowKey: "key",
    ellipsis: true,
    width: 150,
  },
  {
    title: "负责人",
    dataIndex: "managerName",
    key: "managerName",
    rowKey: "key",
    width: 150,
    scopedSlots: {
      customRender: "managerName",
    }
  },
  // {
  //     title: '仓库',
  //     dataIndex: 'warehouse',
  //     key: 'warehouse',
  //     scopedSlots: {
  //         customRender: 'warehouseAction'
  //     }
  // },
  {
    title: "货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
  {
    title: "物流单号",
    key: "logisticsCode",
    dataIndex: "logisticsCode",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsCode",
    },
  },
  {
    title: "推荐物流",
    key: "recommend",
    dataIndex: "recommend",
    width: 220,
    rowKey: "key",
    customRender: (text, record, index) => {
      return record.forwarder + "-" + record.shippingType;
    },
  },
  {
    title: "收货国家",
    key: "receiverNation",
    dataIndex: "receiverNation",
    width: 120,
  },
  {
    title: "客户名称",
    dataIndex: "customerName",
    key: "customerName",
    rowKey: "key",
    width: 120,
  },
  {
    title: "客户子ID",
    dataIndex: "customerId",
    key: "customerId",
    rowKey: "key",
    width: 120,
  },
  {
    title: "Tiktok截止发货时间",
    dataIndex: "rtsSlaTimeDate",
    key: "rtsSlaTimeDate",
    rowKey: "key",
    width: 130,
    customRender: (text, record, index) => {
      return text ? moment(text * 1000).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
  },
  // {
  //   title: "创建时间",
  //   key: "createTime",
  //   dataIndex: "createTime",
  //   rowKey: "key",
  //   width: 200,
  // },
  {
    title: "最终确认时间",
    key: "endConfirmTime",
    dataIndex: "endConfirmTime",
    rowKey: "key",
    width: 200,
  },
  {
    title: "滞留开始时间",
    key: "strandedTime",
    dataIndex: "strandedTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  {
    title: "发货时间",
    key: "deliveryTime",
    dataIndex: "deliveryTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  // {
  //   title: "物流公司",
  //   key: "carrier",
  //   dataIndex: "carrier",
  //   rowKey: 'key',
  //   scopedSlots: {
  //     customRender: "carrierAction",
  //   },
  // },
  // {
  //   title: "运输方式",
  //   key: "carrierWay",
  //   dataIndex: "carrierWay",
  //   rowKey: 'key',
  //   scopedSlots: {
  //     customRender: "carrierWayAction",
  //   },
  // },
  {
    title: "物流账号",
    key: "logisticsCustomerName",
    dataIndex: "logisticsCustomerName",
    rowKey: "key",
    width: 150,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "key",
    width: 270,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const columns_small = [
  {
    title: "发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
    rowKey: "key",
    fixed: "left",
    width: 180,
    scopedSlots: {
      customRender: "shipmentCodeAction",
    },
  },
  {
    title: "订单编号",
    dataIndex: "platformOrderNo",
    key: "platformOrderNo",
    rowKey: "key",
    width: 160,
  },
  {
    title: "收货国家",
    key: "receiverNation",
    dataIndex: "receiverNation",
    width: 120,
  },
  {
    title: "客户名称",
    dataIndex: "customerName",
    key: "customerName",
    rowKey: "key",
    width: 120,
  },
  {
    title: "店铺名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
    rowKey: "key",
    ellipsis: true,
    width: 150,
  },
  {
    title: "货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    rowKey: "key",
    width: 250,
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
  {
    title: "物流单号",
    key: "logisticsCode",
    dataIndex: "logisticsCode",
    rowKey: "key",
    width: 200,
    scopedSlots: {
      customRender: "logisticsCode",
    },
  },
  {
    title: "发货数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return text + "件";
    },
  },
  {
    title: "单/多品",
    key: "singleProduct",
    dataIndex: "singleProduct",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return singleProductTypes[text];
    },
  },
  {
    title: "发货状态",
    dataIndex: "deliveryStatus",
    key: "deliveryStatus",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return deliveryStatusList[text];
    },
  },
  {
    title: "负责人",
    dataIndex: "managerName",
    key: "managerName",
    rowKey: "key",
    width: 150,
    scopedSlots: {
      customRender: "managerName",
    }
  },
  {
    title: "推荐物流",
    key: "recommend",
    dataIndex: "recommend",
    rowKey: "key",
    width: 220,
    customRender: (text, record, index) => {
      return record.forwarder + "-" + record.shippingType;
    },
  },
  // {
  //   title: "创建时间",
  //   key: "createTime",
  //   dataIndex: "createTime",
  //   rowKey: "key",
  //   width: 200,
  // },
  {
    title: "最终确认时间",
    key: "endConfirmTime",
    dataIndex: "endConfirmTime",
    rowKey: "key",
    width: 200,
  },
  {
    title: "滞留开始时间",
    key: "strandedTime",
    dataIndex: "strandedTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  {
    title: "发货时间",
    key: "deliveryTime",
    dataIndex: "deliveryTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  {
    title: "物流账号",
    key: "logisticsCustomerName",
    dataIndex: "logisticsCustomerName",
    rowKey: "key",
    width: 150,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "key",
    width: 250,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const columns_FBA_builtBag = [
  {
    title: "发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
    width: 270,
    fixed: "left",
    scopedSlots: {
      customRender: "shipmentCodeAction",
    },
  },
  {
    title: "上传数据",
    dataIndex: "upload",
    key: "upload",
    width: 180,
    scopedSlots: {
      customRender: "FBAUpload",
    },
  },
  {
    title: "EXCAL",
    dataIndex: "excal",
    key: "excal",
    width: 180,
    scopedSlots: {
      customRender: "FBAexcal",
    },
  },
  {
    title: "同步箱唛",
    dataIndex: "shipping",
    key: "shipping",
    width: 180,
    scopedSlots: {
      customRender: "FBAshipping",
    },
  },
  // {
  //     title: '仓库',
  //     dataIndex: 'warehouse',
  //     key: 'warehouse',
  //     scopedSlots: {
  //         customRender: 'warehouseAction'
  //     }
  // },
  {
    title: "收货国家",
    key: "receiverNation",
    dataIndex: "receiverNation",
    width: 120,
  },
  {
    title: "客户名称",
    dataIndex: "customerName",
    key: "customerName",
    rowKey: "key",
    width: 120,
  },
  {
    title: "店铺名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
    rowKey: "key",
    ellipsis: true,
    width: 150,
  },
  {
    title: "推荐物流",
    key: "recommend",
    dataIndex: "recommend",
    rowKey: "key",
    width: 220,
    customRender: (text, record, index) => {
      return record.forwarder + "-" + record.shippingType;
    },
  },
  {
    title: "货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
  {
    title: "物流单号",
    key: "logisticsCode",
    dataIndex: "logisticsCode",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsCode",
    },
  },
  {
    title: "发货数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return text + "件";
    },
  },
  // {
  //     title: '是否可发',
  //     key: 'canDelivery',
  //     dataIndex: 'canDelivery',
  //     scopedSlots: {
  //         customRender: 'canDeliveryAction'
  //     }
  // },
  {
    title: "单/多品",
    key: "singleProduct",
    dataIndex: "singleProduct",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return singleProductTypes[text];
    },
  },
  {
    title: "发货状态",
    dataIndex: "deliveryStatus",
    key: "deliveryStatus",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return deliveryStatusList[text];
    },
  },
  {
    title: "负责人",
    dataIndex: "managerName",
    key: "managerName",
    rowKey: "key",
    width: 150,
    scopedSlots: {
      customRender: "managerName",
    }
  },
  // {
  //   title: "国家",
  //   key: "receiverNation",
  //   ellipsis: true,
  //   dataIndex: "receiverNation",
  //   width: 180,
  // },
  // {
  //   title: "创建时间",
  //   key: "createTime",
  //   dataIndex: "createTime",
  //   rowKey: "key",
  //   width: 200,
  // },
  {
    title: "最终确认时间",
    key: "endConfirmTime",
    dataIndex: "endConfirmTime",
    rowKey: "key",
    width: 200,
  },
  {
    title: "滞留开始时间",
    key: "strandedTime",
    dataIndex: "strandedTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  {
    title: "发货时间",
    key: "deliveryTime",
    dataIndex: "deliveryTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },

  // {
  //   title: "物流公司",
  //   key: "carrier",
  //   dataIndex: "carrier",
  //   rowKey: 'key',
  //   scopedSlots: {
  //     customRender: "carrierAction",
  //   },
  // },
  // {
  //   title: "运输方式",
  //   key: "carrierWay",
  //   dataIndex: "carrierWay",
  //   rowKey: 'key',
  //   scopedSlots: {
  //     customRender: "carrierWayAction",
  //   },
  // },
  {
    title: "物流账号",
    key: "logisticsCustomerName",
    dataIndex: "logisticsCustomerName",
    rowKey: "key",
    width: 150,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "key",
    width: 270,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const columns_FBA_shipped = [
  {
    title: "发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
    rowKey: "key",
    fixed: "left",
    width: 270,
    scopedSlots: {
      customRender: "shipmentCodeAction",
    },
  },
  {
    title: "同步箱唛",
    dataIndex: "shipping",
    key: "shipping",
    width: 180,
    scopedSlots: {
      customRender: "FBAshipping",
    },
  },
  {
    title: "收货国家",
    key: "receiverNation",
    dataIndex: "receiverNation",
    width: 120,
  },
  {
    title: "客户名称",
    dataIndex: "customerName",
    key: "customerName",
    rowKey: "key",
    width: 120,
  },
  {
    title: "店铺名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
    rowKey: "key",
    ellipsis: true,
    width: 150,
  },
  {
    title: "推荐物流",
    key: "recommend",
    dataIndex: "recommend",
    rowKey: "key",
    width: 220,
    customRender: (text, record, index) => {
      return record.forwarder + "-" + record.shippingType;
    },
  },
  {
    title: "货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
  {
    title: "物流单号",
    key: "logisticsCode",
    dataIndex: "logisticsCode",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsCode",
    },
  },
  {
    title: "发货数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return text + "件";
    },
  },
  {
    title: "单/多品",
    key: "singleProduct",
    dataIndex: "singleProduct",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return singleProductTypes[text];
    },
  },
  {
    title: "发货状态",
    dataIndex: "deliveryStatus",
    key: "deliveryStatus",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return deliveryStatusList[text];
    },
  },
  {
    title: "负责人",
    dataIndex: "managerName",
    key: "managerName",
    rowKey: "key",
    width: 150,
    scopedSlots: {
      customRender: "managerName",
    }
  },
  // {
  //   title: "创建时间",
  //   key: "createTime",
  //   dataIndex: "createTime",
  //   rowKey: "key",
  //   width: 200,
  // },
  {
    title: "最终确认时间",
    key: "endConfirmTime",
    dataIndex: "endConfirmTime",
    rowKey: "key",
    width: 200,
  },
  {
    title: "滞留开始时间",
    key: "strandedTime",
    dataIndex: "strandedTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  {
    title: "发货时间",
    key: "deliveryTime",
    dataIndex: "deliveryTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  {
    title: "物流账号",
    key: "logisticsCustomerName",
    dataIndex: "logisticsCustomerName",
    rowKey: "key",
    width: 150,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "key",
    width: 270,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const columnsSon = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 70,
    fixed: "left",
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "商品图片",
    key: "productImg",
    dataIndex: "productImg",
    width: 140,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  // {
  //   title: "抵扣状态",
  //   key: "deductionNums",
  //   dataIndex: "deductionNums",
  //   width: 140,
  //   scopedSlots: {
  //     customRender: "deductionNums",
  //   },
  // },
  {
    title: "批次包",
    key: "pkgCodeList",
    dataIndex: "pkgCodeList",
    width: 200,
    scopedSlots: {
      customRender: "pkgCodeList",
    },
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
    width: 180,
    scopedSlots: {
      customRender: "shopProductSku",
    },
  },
  {
    title: "平台SKU",
    dataIndex: "productSku",
    key: "productSku",
    width: 250,
  },
  {
    title: "商品数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    width: 140,
  },
  {
    title: "可用库存",
    dataIndex: "checked",
    key: "checked",
    width: 140,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "deliveryTaskDetailId",
    width: 240,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const columns_largeBag = [
  {
    title: "发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
    rowKey: "key",
    fixed: "left",
    width: 270,
    scopedSlots: {
      customRender: "shipmentCodeAction",
    },
  },
  // {
  //     title: '仓库',
  //     dataIndex: 'warehouse',
  //     key: 'warehouse',
  //     scopedSlots: {
  //         customRender: 'warehouseAction'
  //     }
  // },
  {
    title: "发货数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return text + "件";
    },
  },

  {
    title: "客户名称",
    dataIndex: "customerName",
    key: "customerName",
    rowKey: "key",
    width: 120,
  },
  {
    title: "店铺名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
    rowKey: "key",
    ellipsis: true,
    width: 150,
  },
  {
    title: "推荐物流",
    key: "recommend",
    dataIndex: "recommend",
    rowKey: "key",
    width: 220,
    customRender: (text, record, index) => {
      return record.forwarder + "-" + record.shippingType;
    },
  },
  {
    title: "货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
  {
    title: "物流单号",
    key: "logisticsCode",
    dataIndex: "logisticsCode",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "logisticsCode",
    },
  },
  {
    title: "收货国家",
    key: "receiverNation",
    dataIndex: "receiverNation",
    width: 120,
  },
  // {
  //     title: '是否可发',
  //     key: 'canDelivery',
  //     dataIndex: 'canDelivery',
  //     scopedSlots: {
  //         customRender: 'canDeliveryAction'
  //     }
  // },
  {
    title: "单/多品",
    key: "singleProduct",
    dataIndex: "singleProduct",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return singleProductTypes[text];
    },
  },
  {
    title: "发货类型",
    key: "thirdWarehouseType",
    dataIndex: "thirdWarehouseType",
    rowKey: "key",
    width: 150,
    customRender: (text, record, index) => {
      return (
        { 0: "其他", 1: "FBA", 2: "乐天", 3: "SHOPLIST", 4: "ZOZOTOWN" }[
        text
        ] || "其他"
      );
    },
  },
  {
    title: "发货状态",
    dataIndex: "deliveryStatus",
    key: "deliveryStatus",
    rowKey: "key",
    width: 90,
    customRender: (text, record, index) => {
      return deliveryStatusList[text];
    },
  },
  {
    title: "负责人",
    dataIndex: "managerName",
    key: "managerName",
    rowKey: "key",
    width: 150,
    scopedSlots: {
      customRender: "managerName",
    },
  },
  // {
  //   title: "国家",
  //   key: "receiverNation",
  //   ellipsis: true,
  //   dataIndex: "receiverNation",
  //   width: 180,
  // },
  // {
  //   title: "创建时间",
  //   key: "createTime",
  //   dataIndex: "createTime",
  //   rowKey: "key",
  //   width: 200,
  // },
  {
    title: "最终确认时间",
    key: "endConfirmTime",
    dataIndex: "endConfirmTime",
    rowKey: "key",
    width: 200,
  },
  {
    title: "滞留开始时间",
    key: "strandedTime",
    dataIndex: "strandedTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  {
    title: "发货时间",
    key: "deliveryTime",
    dataIndex: "deliveryTime",
    rowKey: "key",
    customRender: (text, record, index) => {
      return text || "-";
    },
    width: 200,
  },
  // {
  //   title: "物流公司",
  //   key: "carrier",
  //   dataIndex: "carrier",
  //   rowKey: 'key',
  //   scopedSlots: {
  //     customRender: "carrierAction",
  //   },
  // },
  // {
  //   title: "运输方式",
  //   key: "carrierWay",
  //   dataIndex: "carrierWay",
  //   rowKey: 'key',
  //   scopedSlots: {
  //     customRender: "carrierWayAction",
  //   },
  // },
  {
    title: "物流账号",
    key: "logisticsCustomerName",
    dataIndex: "logisticsCustomerName",
    rowKey: "key",
    width: 150,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "key",
    width: 270,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const operationCol = [
  {
    title: "场景",
    dataIndex: "nodeName",
    key: "nodeName",
    rowKey: "key",
  },
  {
    title: "内容",
    dataIndex: "bizContent",
    key: "bizContent",
    rowKey: "key",
  },
  {
    title: "操作人",
    dataIndex: "creatorName",
    key: "creatorName",
    rowKey: "key",
  },
  {
    title: "操作时间",
    dataIndex: "updateTime",
    key: "updateTime",
    rowKey: "key",
  }
];

export const additionCol = [
  {
    title: "附加项",
    dataIndex: "additionName",
    key: "additionName",
    rowKey: "key",
  },
  {
    title: "辅料SKU",
    dataIndex: "ingredientsSku",
    key: "ingredientsSku",
    rowKey: "key",
  },
  {
    title: "辅料名称",
    dataIndex: "ingredientsName",
    key: "ingredientsName",
    rowKey: "key",
  },
  {
    title: "辅料图片",
    dataIndex: "image",
    key: "image",
    rowKey: "key",
    scopedSlots: {
      customRender: "image",
    },
  },
]

export const columnsSon_waitUp = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 70,
    fixed: "left",
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "商品图片",
    key: "productImg",
    dataIndex: "productImg",
    width: 100,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "批次包",
    key: "deductionNums",
    dataIndex: "deductionNums",
    width: 260,
    scopedSlots: {
      customRender: "deductionNums",
    },
    // customRender: (text, record, index) => {
    //   return ( text == 0 ) ? '未抵扣' : ( text == record.deliveryNums ) ? '已抵扣' : '部分抵扣'
    // },
  },
  {
    title: "商品SPU",
    dataIndex: "productCode",
    key: "productCode",
    width: 150
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
    width: 160,
    scopedSlots: {
      customRender: "shopProductSku",
    },
  },
  {
    title: "平台SKU",
    dataIndex: "productSku",
    key: "productSku",
    width: 250,
  },
  {
    title: "商品数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    width: 80,
  },
  {
    title: "可用库存",
    dataIndex: "checked",
    key: "checked",
    width: 80,
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "deliveryTaskDetailId",
    width: 240,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const deductionColumns = [
  {
    title: "批次包",
    dataIndex: "pkgCode",
    key: "pkgCode",
    rowKey: "key",
  },
  {
    title: "数量",
    dataIndex: "nums",
    key: "nums",
    rowKey: "key",
  },
  {
    title: "库区",
    dataIndex: "actualRegionName",
    key: "actualRegionName",
    rowKey: "key",
  },
  {
    title: "库位/容器",
    dataIndex: "gridCode",
    key: "gridCode",
    rowKey: "key",
  },
  {
    title: "抵扣时间",
    dataIndex: "deductionTime",
    key: "deductionTime",
    rowKey: "key",
  },
]

